<div *ngIf="filtersForm" [formGroup]="filtersForm" style="padding: 5px">
  <mat-card-title class="filters-header" filtersStickyHeader>
    <ng-container
      *ngTemplateOutlet="
        titleTemplate;
        context: {
          filtersForm: filtersForm,
          profileForm: selectedProfileForm
        }
      "
    ></ng-container>
  </mat-card-title>

  <div
    cdkDropList
    #enabledList="cdkDropList"
    [cdkDropListDisabled]="!isCustomizedMode"
    [cdkDropListData]="enabledFilters"
    [cdkDropListConnectedTo]="[disabledList]"
    class="drop-list drop-list_enabled"
    (cdkDropListDropped)="drop($event)"
  >
    <div *ngIf="isCustomizedMode" class="active-filters-title">
      {{ 'common.uiKit.monitoring.label.enabled' | translate }}
    </div>
    <ui-monitoring-filters-field
      *ngFor="let filterName of enabledFilters"
      [filterTypeByName]="filterTypeByName"
      [filterSelectOptionsByName]="filterSelectOptionsByName"
      [label]="'monitoring.filters.' + filterName | translate"
      [name]="filterName"
      [isFieldEnabled]="true"
      [isDraggedMode]="isCustomizedMode"
      [filtersFormControlOrGroup]="filtersForm.get(filterName)"
      [filterRadioOptionsByName]="filterRadioOptionsByName"
      [optionValueKeyForChipsInputSearchGeneric]="chipsInputOptionValueMap.get(filterName)"
      [optionNameKeyForChipsInputSearchGeneric]="recordTypeFilterMap.get(filterName)"
      cdkDrag
      (changeFieldState)="changeFieldState($event, transportFiltersState.Disabled)"
    ></ui-monitoring-filters-field>
  </div>

  <div
    cdkDropList
    #disabledList="cdkDropList"
    [hidden]="!isCustomizedMode"
    [cdkDropListDisabled]="!isCustomizedMode"
    [cdkDropListData]="disabledFilters"
    [cdkDropListConnectedTo]="[enabledList]"
    class="drop-list drop-list_disabled"
    (cdkDropListDropped)="drop($event)"
  >
    <div *ngIf="isCustomizedMode" class="active-filters-title">
      {{ 'common.uiKit.monitoring.label.disabled' | translate }}
    </div>
    <ui-monitoring-filters-field
      *ngFor="let filterName of disabledFilters"
      [filterTypeByName]="filterTypeByName"
      [filterSelectOptionsByName]="filterSelectOptionsByName"
      [label]="'monitoring.filters.' + filterName | translate"
      [name]="filterName"
      [isFieldEnabled]="false"
      [isDraggedMode]="isCustomizedMode"
      [filtersFormControlOrGroup]="filtersForm.get(filterName)"
      cdkDrag
      (changeFieldState)="changeFieldState($event, transportFiltersState.Enabled)"
    ></ui-monitoring-filters-field>
  </div>
</div>

<ng-template #titleTemplate let-profileForm="profileForm" let-filtersForm="filtersForm">
  <ng-container *ngIf="!isCustomizedMode; else filterSettingsTitleTemplate">
    <div class="tw-flex tw-justify-between tw-w-full tw-pb-4" *ngIf="isDialogBox">
      <h1 class="tw-text-h3 tw-font-regular tw-m-0" mat-dialog-title *ngIf="modalBoxTitle">
        {{ modalBoxTitle | translate }}
      </h1>
      <h1 class="tw-text-h3 tw-font-regular tw-m-0" mat-dialog-title *ngIf="!modalBoxTitle">
        {{ 'monitoring.filters.filters' | translate }}
      </h1>
      <button mat-icon-button (click)="close()">
        <ui-svg-icon [name]="iconNameList.Close" [width]="32"></ui-svg-icon>
      </button>
    </div>

    <div class="tw-flex">
      <div class="filters-header__icon tw-flex">
        <ui-svg-icon [name]="iconNameList.Filter" [width]="32" class="tw-ml-0 tw-mr-2"></ui-svg-icon>
        <ui-svg-icon
          *ngIf="!isCustomizedMode && isFiltersCustomizable && !isDialogBox"
          [name]="iconNameList.Edit"
          [width]="20"
          class="edit-filters"
          (click)="enableCustomizeMode.emit()"
        ></ui-svg-icon>
      </div>

      <span *ngIf="!!filtersCount" class="tw-flex filters-count">{{ filtersCount }}</span>
      <div class="tw-flex">
        <ui-action-button
          *ngIf="!isDialogBox"
          class="apply-filters-button"
          [action]="buttonAction.Apply"
          [size]="buttonSize.XS"
          [disabled]="filtersForm.invalid || filtersForm.pristine"
          (buttonClick)="apply()"
        ></ui-action-button>
        <ng-container *ngIf="canCreateOrUpdateProfile && isProfileVisible && !modalBoxTitle">
          <ui-action-button
            *ngIf="filtersForm.valid && filtersForm.pristine && !profileForm.value?.id"
            class="apply-filters-button"
            [action]="buttonAction.Apply"
            [text]="'monitoring.materialPlannerProfile.button.createProfile' | translate"
            [size]="buttonSize.XS"
            (buttonClick)="openCreateProfileDialog.emit()"
          ></ui-action-button>
        </ng-container>
      </div>
    </div>

    <ng-content></ng-content>

    <ui-select-profile
      *ngIf="isProfileVisible"
      [name]="profileForm.get('name').value"
      [id]="profileForm.get('id').value"
      [isUpdateProfileAvailable]="isUpdateProfileAvailable"
      [defaultProfileControl]="defaultProfileControl"
      (removeProfile)="removeProfile.emit()"
      (selectProfile)="selectProfile.emit()"
      (updateProfile)="updateProfile.emit()"
    ></ui-select-profile>
  </ng-container>
</ng-template>

<ng-template #filterSettingsTitleTemplate>
  <div class="filters-config tw-flex">
    <button class="filters-config__back-btn size-md" mat-icon-button (click)="cancelUpdatingFilterSettings.emit()">
      <ui-svg-icon [name]="iconNameList.BackLeft" class="tw-mr-0"></ui-svg-icon>
    </button>

    <div class="filters-config__title">
      {{ 'common.uiKit.monitoring.label.filtersConfig' | translate }}
    </div>
    <ui-action-button
      class="apply-filters-button"
      [action]="buttonAction.Apply"
      [size]="buttonSize.L"
      [text]="'common.button.save' | translate"
      (buttonClick)="updateFilterSettings.emit()"
    ></ui-action-button>
  </div>
</ng-template>
<div class="button-container" *ngIf="isDialogBox">
  <button mat-button (click)="reset()" class="cancel-button">
    {{ 'common.button.resetAll' | translate }}
  </button>

  <ui-action-button
    class="apply-filters-button apply-button"
    [action]="buttonAction.Apply"
    [size]="buttonSize.S"
    [type]="buttonType.Primary"
    [disabled]="filtersForm.invalid || filtersForm.pristine"
    (buttonClick)="apply()"
  ></ui-action-button>
</div>
